class ValuesContent extends HTMLElement {
  constructor() {
    super();
    this.headers = this.querySelectorAll('.value-box__header');
    this.boxes = this.querySelectorAll('.value-box');
    this.boxesLenght = this.boxes.length;
    this.currentBox = 1;
    
    this.headers.forEach(header => {
      header.addEventListener('click', this.onHeaderClick.bind(this));
    })
    window.addEventListener('resize', this.adjustHeight.bind(this));
    this.startAnimation();
  }

  onHeaderClick(e) {
    const box = e.target.closest('.value-box');

    // 1. 'active' class
    if (box.classList.contains('active')) return;

    // a. Remove 'active' class from all boxes
    this.boxes.forEach(box => box.classList.remove('active'));

    // a. Add 'active' class to this box
    box.classList.add('active');

    // 2. Reveal content
    this.revealContent();

    // 3. Update currentBox
    this.currentBox = parseInt(box.dataset.index);

    // 4. Stop animation for 15 seconds
    this.intervalManager(false);
    setTimeout(() => this.intervalManager(true), 10000);
  }

  revealContent() {
    const box = this.querySelector('.value-box.active');
    const content = box.querySelector('.value-box__content');
    const contentContainer = box.querySelector('.value-box__content-container');

    // 1. Close all content
    this.boxes.forEach(box => box.querySelector('.value-box__content').style.maxHeight = 0);

    // 2. Open this content
    content.style.maxHeight = getComputedStyle(contentContainer).height;
  }

  adjustHeight() {
    const box = this.querySelector('.value-box.active');
    if (!box) return;
    const content = box.querySelector('.value-box__content');
    const contentContainer = box.querySelector('.value-box__content-container');

    content.style.maxHeight = getComputedStyle(contentContainer).height;
  }

  startAnimation() {
    const valuesContent = this;
    const firstBoxHeader = this.querySelector('.value-box--1 .value-box__header');

    // 3. Call back
    const revealContent = function (entries, observer) {
      const [entry] = entries;
      
      if (!entry.isIntersecting) return;

      // a. First box
      valuesContent.openValueBox(firstBoxHeader);

      // b. Next Boxes
      valuesContent.intervalManager(true);

      observer.unobserve(entry.target);
    }

    // 1. Section observer
    const sectionObserver = new IntersectionObserver(revealContent, {
      root: null,
      threshold: 0.15,
    });

    // 2. Observe
    sectionObserver.observe(this);
  }

  intervalManager(status) {
    if (status) {
      clearInterval(this.nextBoxInterval);
      this.nextBoxInterval = setInterval(() => this.nextBoxes(), 5000);
    } else {
      clearInterval(this.nextBoxInterval);
    }
  }

  nextBoxes() {
    if (this.currentBox === this.boxesLenght) this.currentBox = 1;
    else this.currentBox += 1;

    const nextBoxHeader = this.querySelector(`.value-box--${this.currentBox} .value-box__header`);
    this.openValueBox(nextBoxHeader);
  }

  openValueBox(header) {
    const box = header.closest('.value-box');

    // 1. 'active' class
    if (box.classList.contains('active')) return;

    // a. Remove 'active' class from all boxes
    this.boxes.forEach(box => box.classList.remove('active'));

    // a. Add 'active' class to this box
    box.classList.add('active');

    // 2. Reveal content
    this.revealContent();

    // 3. Update currentBox
    this.currentBox = parseInt(box.dataset.index);
  }
}

customElements.define('values-content', ValuesContent);